import React, { useState, useMemo } from 'react';
import FuzzySearch from 'fuzzy-search';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Badge } from '../../ui/badge';
import { Search } from 'lucide-react';

import { BoardLink } from '../../Links';

const TOP_N_BOARDS = 20;

interface BoardsProps {
  data: any[];
  isMobile: boolean;
}

export default function Boards({ data: initialData, isMobile }: BoardsProps) {
  const [onlyTop, setOnlyTop] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  
  const searcher = useMemo(() => {
    if (initialData.length > 0) {
      return new FuzzySearch(initialData, ['title', 'tag', 'alias', 'description'], {
        caseSensitive: false,
      });
    }
    return null;
  }, [initialData]);

  const data = useMemo(() => {
    if (searchQuery && searcher) {
      return searcher.search(searchQuery);
    }
    return initialData;
  }, [searchQuery, searcher, initialData]);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const q = event.target.value;
    setSearchQuery(q);
    if (q) {
      setOnlyTop(false);
    } else {
      setOnlyTop(true);
    }
  };

  return (
    <div>
      {!isMobile && (
        <div className="relative mb-6">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <Input
            className="pl-10"
            placeholder="搜尋板 ID / 名稱"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {data
          .slice(0, onlyTop ? TOP_N_BOARDS : data.length)
          .map((board) => (
            <BoardLink key={board.id} id={board.id}>
              <Badge variant="secondary" className="bg-blue-600 text-white hover:bg-blue-700">
                {board.title} {board.alias ?? board.tag}
              </Badge>
            </BoardLink>
          ))}
      </div>
      {onlyTop && data.length > TOP_N_BOARDS && (
        <Button
          variant="outline"
          className="w-full mt-4"
          onClick={() => setOnlyTop(false)}
        >
          看更多
        </Button>
      )}
    </div>
  );
}